<template>
<div
	class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center p-0 m-0 pt-2 ps-3 pb-2 mb-1 border-bottom"
>
	<div class="fs-4 col-auto">
		Звіти організації
	</div>

	<span
		class="d-inline-block"
		tabindex="0"
		data-bs-toggle="tooltip"
		data-bs-title="створити звіт організації"
	>
		<button
			type="button"
			class="btn btn-outline-secondary me-4"
			@click="isCreatePopupOpen=true"
			:disabled="!accountStore.permissions.includes('make_reports')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				viewBox="0 0 16 16"
				fill="currentColor"
				stroke="currentColor"
				stroke-width="0.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				class=""
			>
				<path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5"/>
				<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
			</svg>
		</button>
	</span>
</div>
<!-- <pick-period-vidget
	class="py-2 me-1"
	:tiles="new Array(
		['1 місяць', 30],
		['3 місяці', 92],
		['6 місяців', 184],
		['1 рік', 365],)"
	@value="(v) => { reportsPeriodDaysFromNow = v; beginUpdate(); }"
/> -->

<rpc-table
	class="m-0 mx-1 p-0"
	:filter-jobs="jobsFilter"
	:rpc-tasks-update-rate="$options.updatePeriod"
	:show-state-columns="false"
/>

<create-organization-report-popup
	v-if="isCreatePopupOpen"
	@created="isCreatePopupOpen = false;"
	@close="isCreatePopupOpen = false;"
	@click.stop=""
/>
</template>


<script>
import { useTooltip } from '@/composables/bootstrap-tooltip.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { rpcTaskSchema } from '@/composables/rpcTasks.js'
//import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import {
//	subtractHoursFromNowDate,
} from '@/helpers.js'
import RpcTable from '@/components/StationView/RpcTable.vue'
import CreateOrganizationReportPopup from './CreateOrganizationReportPopup.vue'


export default {
	updatePeriod: 60000,

	components: {
		//Vidgets/PickPeriodVidget,
		RpcTable,
		CreateOrganizationReportPopup,
	},

	props: {},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const jobsFilter = [
			rpcTaskSchema.job.allowed.buildStationReport.key,
			rpcTaskSchema.job.allowed.buildOrganizationReport.key,
		]

		useTooltip()

		return {
			accountStore,
			stationsStore,
			jobsFilter,
		}
	},

	data() {
		return {
			// Update timeout
			updateInterval: null,
			//
			//reportsPeriodDaysFromNow: 31,
			// Create organization report popup
			isCreatePopupOpen: false,
		}
	},

	async created() {
	},

	mounted() {
		document.title = "Звіти"
	},

	methods: {},

	computed: {},
}
</script>


<style scoped>
</style>